var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 448",
    style: {
      enableBackground: "new 0 0 448 448"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224,117.2c120,0,212.2,50.5,212.2,106S343.9,329.3,224,329.3c-120,0-212.2-50.5-212.2-106.1 S104.1,117.2,224,117.2 M224,105.5c-123.7,0-224,52.7-224,117.8s100.3,117.8,224,117.8s224-52.7,224-117.8S347.7,105.5,224,105.5z  M152.7,213.8c-5.5,28.4-25.1,25.4-49.1,25.4l9.6-49.4C139.9,189.8,157.9,186.9,152.7,213.8L152.7,213.8z M68.2,289.3h25.7l6.1-31.4 c28.8,0,46.6,2.1,63.1-13.4c18.3-16.8,23-46.7,10-61.7c-6.8-7.8-17.7-11.7-32.6-11.7H91.1L68.2,289.3z M198.2,139.8h25.6l-6.1,31.4 c22.1,0,42.5-1.6,52.4,7.5c10.4,9.5,5.4,21.7-5.8,79.2h-25.9c10.8-55.6,12.8-60.2,8.9-64.4c-3.8-4.1-12.4-3.2-33.2-3.2l-13.2,67.6 h-25.5L198.2,139.8L198.2,139.8z M353.5,213.8c-5.6,28.8-25.7,25.4-49.1,25.4l9.6-49.4C340.8,189.8,358.7,186.9,353.5,213.8 L353.5,213.8z M268.9,289.3h25.8l6.1-31.4c30.2,0,47,1.8,63.1-13.4c18.3-16.8,23-46.7,10-61.7c-6.8-7.8-17.7-11.7-32.5-11.7h-49.5 L268.9,289.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.7debe879c26caa4eb3aa71b6900539b4.svg";
export { ForwardRef as ReactComponent };